import React, { useEffect, useRef, useState } from "react";
import * as faceapi from "face-api.js";
import "./faceattendance.css";
import {
  saveUser,
  getUsers,
  markAttendance,
  getAttendance
} from "./utils";
import { Link } from "react-router-dom";

const FaceAttendance = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [name, setName] = useState("");
  const [users, setUsers] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("markattendance");

  // ✅ Load Models
  useEffect(() => {
    const loadModels = async () => {
      try {
        const MODEL_URL = "/models";

        await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
        await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
        await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);

        setModelsLoaded(true);
        startVideo();
      } catch (err) {
        console.error("Model loading error:", err);
      }
    };

    loadModels();
    setUsers(getUsers());
    setAttendance(getAttendance());
    
  }, []);

  
const nowtime = new Date();
const formatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
});
  // ✅ Start Camera
  const startVideo = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Camera error:", err);
      alert("Camera access denied ❌");
    }
  };

  // ✅ Capture Face Safely
  const captureFace = async () => {
    if (!videoRef.current || videoRef.current.readyState !== 4) {
      alert("Camera not ready");
      return null;
    }

    const detection = await faceapi
      .detectSingleFace(
        videoRef.current,
        new faceapi.TinyFaceDetectorOptions()
      )
      .withFaceLandmarks()
      .withFaceDescriptor();

    return detection;
  };

  // ✅ Register User
  const registerUser = async () => {
    if (!name.trim()) return alert("Enter name");

    const face = await captureFace();
    if (!face) return alert("Face not detected ❌");

console.log(formatter.format(nowtime));
    saveUser({
      name,
      descriptor: Array.from(face.descriptor),
      time:formatter.format(nowtime)
    });

    setUsers(getUsers());
    setName("");
    alert("✅ User Registered");
  };

  // ✅ Mark Attendance
  const markUserAttendance = async () => {
    if (users.length === 0) {
      return alert("No users registered ❌");
    }

    const face = await captureFace();
    if (!face) return alert("Face not detected ❌");

    const labeledDescriptors = users.map(
      (user) =>
        new faceapi.LabeledFaceDescriptors(user.name, [
          new Float32Array(user.descriptor)
        ])
    );

    const matcher = new faceapi.FaceMatcher(labeledDescriptors, 0.5);
    const match = matcher.findBestMatch(face.descriptor);

    if (match.label === "unknown") {
      alert("❌ Not recognized");
    } else {
      markAttendance(match.label);
      setAttendance(getAttendance());
      alert(`✅ ${match.label} marked`);
    }
  };

  return (
    <div className="facetracker">
      <h2>Face Attendance</h2>

      <div className="faceheader-icon">
        {activeTab === "markattendance" && (
          <button onClick={() => setActiveTab("register")}>➕</button>
        )}

        {activeTab === "register" && (
          <button onClick={() => setActiveTab("markattendance")}>📌</button>
        )}

        <Link to="attendance">
          <button title="Attendance list">📋</button>
        </Link>
      </div>

      {/* ✅ FIXED VIDEO */}
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="video"
      />

      <canvas ref={canvasRef} style={{ display: "none" }} />

      {/* REGISTER */}
      {activeTab === "register" && (
        <div className="Register-section">
          <div className="formlabeldiv">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label>Name</label>
          </div>

          <button onClick={registerUser} className="button">
            Register
          </button>
        </div>
      )}

      {/* MARK ATTENDANCE */}
      {activeTab === "markattendance" && (
        <div className="mark-section">
          <button onClick={markUserAttendance} className="button">
            Mark Attendance
          </button>
        </div>
      )}
    </div>
  );
};

export default FaceAttendance;